<template lang="pug">
  v-form(ref="form")
    v-row(no-gutters)
      v-col(:cols="blast.enabled ? 12 : 7")
        v-card.rounded-lg.content-box.pa-6(outlined)
          v-row
            v-col(:cols="blast.enabled ? 7 : 12")
              v-row(no-gutters align="center")
                v-col.grow
                  div.d-flex.align-center
                    .text-md.font-semibold Whatsapp API
                    y-chip.ml-2(v-if="blastData && blast.enabled && checkPaused(blastData)" label="Paused" color="red")
                v-col.shrink(v-if="blastData && blast.enabled && offer.status !== 'draft'")
                  y-button.mr-3(label="Deliverance details" outlined size="xxs" @click="showDeliveranceDetailsDialog = true")
                v-col.shrink
                  y-switch.mb-n3(v-model="blast.enabled")

              v-row.my-4(v-if="blast.enabled")
                v-divider.neutral300

              template(v-if="blast.enabled")
                //- Thank you message
                div.text-md.font-semibold.neutral700--text Write your thank you message
                v-textarea.text-sm.mt-2.round-xl(ref="textarea" v-model="blast.content" placeholder="Type your message here" outlined rows="6" hide-details="auto" :rules="rules.not_empty" @input="updateCursor" @change="updateCursor" @focus="updateCursor")
                div.text-sm.font-semibold.neutral700--text.mt-5 Insert field:
                v-row(no-gutters)
                  v-col.shrink.pr-3.pt-2
                    v-chip(link small outlined color="neutral400" @click="insertValue('offer_name')")
                      span.neutral700--text Offer details
                  v-col.shrink.pr-3.pt-2
                    v-chip(link small outlined color="neutral400" @click="insertValue('recipient_name')")
                      span.neutral700--text Customer name
                  v-col.shrink.pr-3.pt-2
                    v-chip(link small outlined color="neutral400" @click="insertValue('company_name')")
                      span.neutral700--text Clinic’s name
                  v-col.shrink.pr-3.pt-2
                    v-chip(link small outlined color="neutral400" @click="insertValue('company_phone')")
                      span.neutral700--text Phone number
                  v-col.shrink.pr-3.pt-2
                    template(v-if="offer.redeem_method != 'show_message'")
                      v-chip(link small outlined color="neutral400" @click="insertValue('offer_code')")
                        span.neutral700--text Promo code
                  v-col.shrink.pr-3.pt-2
                    v-chip(v-if="offer.end_at" link small outlined color="neutral400" @click="insertValue('expiry_date')")
                      span.neutral700--text Expiry date

              template(v-if="blast.enabled")
                v-row.my-4
                  v-divider.neutral300
                //- Image upload
                div.d-flex.align-center
                  div
                    div.text-sm.font-semibold.neutral700--text Upload image (optional)
                    div.text-sm.font-medium.neutral700--text Include an image in your message
                  v-spacer
                  div
                    y-switch(v-model="blast.image_enabled")
                v-row.mt-5(v-if="resizeImageFileUrl" dense align="center")
                  v-col.shrink
                    v-img(:src="resizeImageFileUrl" contain max-height="150" max-width="300")
                      template(v-slot:placeholder)
                        v-row(class="fill-height ma-0" align="center" justify="center")
                          v-progress-circular(indeterminate color="grey")
                  v-col
                    y-button(label="Remove" size="sm" :loading="isLoading" outlined button-class="px-3" @click="removeImage")
                v-card.round-xl.pa-8.mt-4(v-else link outlined style="border-style: dashed; border-color: var(--v-neutral400)")
                  .text-center
                    v-avatar.mb-3(color="neutral300" size="40")
                      v-icon(color="neutral500" size="18") $yzi-image-01
                    .mb-1.text-sm
                      span.info500--text.font-semibold {{ $t('click_to_upload') }}
                      span.neutral700--text {{ $t('or_drag_and_drop') }}
                    .text-xs.neutral500--text {{ $t('photo_upload_limitation') }}
                  input.input-change-layout(ref="file" type="file" @change="onFileChange" accept="image/*")

                v-row.my-4
                  v-divider.neutral300
                //- Hyperlink
                div.d-flex.align-center
                  div
                    div.text-sm.font-semibold.neutral700--text Button link (optional)
                    div.text-sm.font-medium.neutral700--text Attach a hyperlink to your message
                  v-spacer
                  div
                    y-switch(v-model="blast.hyperlink_enabled")
                v-row.mt-4
                  v-col
                    div.text-sm.font-semibold.neutral500--text Link
                    v-text-field.text-sm.round-xl.mt-2(v-model="blast.hyperlink_url" placeholder="Enter your link" outlined dense height="48" hide-details="auto")
                  v-col
                    div.text-sm.font-semibold.neutral500--text Text on button
                    v-text-field.text-sm.round-xl.mt-2(v-model="blast.hyperlink_text" placeholder="Enter your link" outlined dense height="48" counter="20" hide-details="auto" )

                v-row.my-4
                  v-divider.neutral300
                //- Blast settings
                div.text-sm.font-semibold.neutral700--text.mt-6 Blast settings
                v-card.round-xl.mt-2.pa-3(outlined color="neutral200" style="border-color: var(--v-neutral300) !important;")
                  v-radio-group.mt-0(v-model="blast.send_to" hide-details)
                    v-radio(value="all" color="neutral700")
                      template(v-slot:label)
                        div.text-sm.font-medium.neutral700--text Send to everyone
                    div.ml-8.mb-3(v-if="blast.send_to === 'all'")
                      v-radio-group.mt-0(v-model="sendCue" hide-details)
                        v-radio(value="scheduled" color="neutral700")
                          template(v-slot:label)
                            div.text-sm.font-medium.neutral700--text On specific date and time
                        template(v-if="sendCue === 'scheduled'")
                          v-row.mb-2.ml-6(dense)
                            v-col(cols="4")
                              date-picker-field(v-model="date" required :min="getTodayDate()")
                            v-col(cols="4")
                              v-text-field.text-sm.round-xl(v-model="time" outlined dense height="48" :rules="rules.not_empty" type="time" hide-details="auto")
                        v-radio(value="offer_ended" color="neutral700")
                          template(v-slot:label)
                            div.text-sm.font-medium.neutral700--text Right after the campaign ended
                    v-radio(value="redeemed_recipient" color="neutral700" style="align-items: unset;")
                      template(v-slot:label)
                        div.text-sm.font-medium.neutral700--text Send to customer that redeemed the offer
                    div.ml-8(v-if="blast.send_to === 'redeemed_recipient'")
                      v-radio-group.mt-0(v-model="sendCue" hide-details)
                        v-radio(value="offer_redeemed" color="neutral700")
                          template(v-slot:label)
                            div.text-sm.font-medium.neutral700--text Send after specific minute after redemption
                        template(v-if="sendCue === 'offer_redeemed'")
                          v-row.mb-3(no-gutters)
                            v-col(cols="6")
                              v-text-field.text-sm.round-xl.pl-8(v-model="minutes" placeholder="0" outlined dense height="48" :rules="rules.has_quantity" suffix="minute" type="number" hide-details="auto")
                        v-radio(value="scheduled" color="neutral700")
                          template(v-slot:label)
                            div.text-sm.font-medium.neutral700--text On specific date and time
                        template(v-if="sendCue === 'scheduled'")
                          v-row.mb-3.ml-6(dense)
                            v-col(cols="4")
                              date-picker-field(v-model="date" required :min="getTodayDate()")
                            v-col(cols="4")
                              v-text-field.text-sm.round-xl(v-model="time" outlined dense height="48" :rules="rules.not_empty" type="time" hide-details="auto")
                        v-radio(value="offer_ended" color="neutral700")
                          template(v-slot:label)
                            div.text-sm.font-medium.neutral700--text Right after the campaign ended

            v-divider.neutral300(v-if="blast.enabled" vertical)
            // Preview
            v-col(v-if="blast.enabled" cols="5")
              whatsapp-preview(title="Offer message preview" :content="blast.content")

    .dialogs
      deliverance-details-dialog(v-if="showDeliveranceDetailsDialog" :open.sync="showDeliveranceDetailsDialog" :blast-data="blastData")

</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {DateTime} from 'luxon'
import {resizeImage} from '@/utils'
import DatePickerField from '@/components/clinic/marketing/DatePickerField.vue'
import WhatsappPreview from '@/components/clinic/marketing/WhatsappPreview.vue'
import DeliveranceDetailsDialog from '@/components/clinic/marketing/dialogs/DeliveranceDetailsDialog.vue'

export default {
  components: {
    DatePickerField, WhatsappPreview, DeliveranceDetailsDialog
  },
  props: {
    blastData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isFetching: false,
      isLoading: false,
      showDeliveranceDetailsDialog: false,
      resizeImageFileUrl: null,
      resizeImageFile: null,
      cursorPosition: 0,
      minutes: 0,
      sendCue: 'offer_ended',
      time: '00:00',
      date: null,
      blast: {
        name: 'Thank you message',
        send_to: 'all',
        type: 'thank_you',
        method: 'whatsapp',
        enabled: false,
      },
      schedules: [{time: '00:00'}],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      offer: 'marketing/getOffer'
    }),
    textarea() {
      return this.$refs.textarea.$el.querySelector('textarea')
    }
  },
  watch: {},
  mounted() {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData() {
      if (this.blastData) {
        let blast = JSON.parse(JSON.stringify(this.blastData))
        if (blast.schedules.length) {
          this.date = DateTime.fromISO(blast.schedules[0].scheduled_for).toFormat('yyyy-MM-dd'),
              this.time = DateTime.fromISO(blast.schedules[0].scheduled_for).toFormat('HH:mm')
        }
        if (blast.image) {
          this.resizeImageFileUrl = blast.image.file
        }
        this.sendCue = blast.send_cue
        this.minutes = blast.auto_send_delay_time_value
        this.blast = blast
      }
    },
    updateCursor() {
      const postion = this.textarea.selectionStart
      if (!postion) {
        setTimeout(() => {
          this.cursorPosition = this.textarea.selectionStart
        }, 500)
      } else {
        this.cursorPosition = this.textarea.selectionStart
      }
    },
    insertValue(value) {
      let text = ''
      const code = `{{ ${value} }}`
      if (this.blast.content) {
        text = `${this.blast.content.substring(0, this.cursorPosition)}${code}${this.blast.content.substring(this.cursorPosition, this.blast.content.length)}`
      } else {
        text = code
      }
      this.$set(this.blast, 'content', text)
    },
    deleteSchedule() {
      this.schedules.pop()
    },
    validateData () {
      return this.$refs.form.validate()
    },
    async saveData () {
      if (!this.validateData()) {
        return
      }
      if (!this.blastData && !this.blast.enabled) {
        return
      }
      this.isLoading = true
      const payload = this.getPayload()
      if (this.blast.id) {
        const { data } = await this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts/${this.blast.id}`, payload)
        if (this.resizeImageFile) {
          return this.updateImage(data.id)
        }
        this.isLoading = false
        return
      }
      const { data } = await this.$axios.post(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts`, payload)
      if (this.resizeImageFile) {
        return this.updateImage(data.id)
      }
      this.isLoading = false
    },
    updateImage(id) {
      let formdata = new FormData()
      formdata.append('image', this.resizeImageFile)
      return this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts/${id}`, formdata)
          .then(() => {})
          .finally(() => {
            this.isLoading = false
          })
    },
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], 'company_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    },
    removeImage() {
      if (!(this.blast.image && this.blast.image.id)) {
        this.resizeImageFileUrl = null
        this.resizeImageFile = null
        return
      }
      this.isLoading = true
      this.$axios.delete(`/images/${this.blast.image.id}`)
          .then(() => {
            this.resizeImageFileUrl = null
            this.resizeImageFile = null
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_upload_image')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) {
                  message = data
                }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    getTodayDate() {
      return DateTime.local().toFormat('yyyy-MM-dd')
    },
    getPayload () {
      if (!this.blast.enabled) {
        return {
          enabled: false
        }
      }
      let payload = {
        enabled: true,
        name: this.blast.name,
        method: this.blast.method,
        type: this.blast.type,
        content: this.blast.content,
        send_to: this.blast.send_to,
        image_enabled: this.blast.image_enabled,
        hyperlink_enabled: this.blast.hyperlink_enabled,
        hyperlink_url: this.blast.hyperlink_url,
        hyperlink_text: this.blast.hyperlink_text,
      }
      payload.send_cue = this.sendCue
      if (this.sendCue === 'scheduled') {
        payload.schedules = [`${this.date} ${this.time}`]
      }
      if (this.sendCue === 'offer_redeemed') {
        payload.auto_send_delay_time_value = this.minutes
        payload.auto_send_delay_time_unit = 'minutes'
      }
      return payload
    },
    checkPaused (data) {
      let paused = false
      if (data.schedules.find(f => f.status === 'paused')) {
        paused = true
      }
      return paused
    },
  },
}
</script>

<style lang="scss" scoped>
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}

::v-deep {
  .v-data-table__wrapper table tbody tr:hover {
    cursor: pointer;
    background: var(--v-neutral200) !important;
  }

  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  }

  .error--text {
    color: var(--v-danger500) !important;

    fieldset {
      border-color: var(--v-danger500);
    }
  }

  .search-field {
    .v-input__append-inner {
      margin-top: 12px !important;
    }
  }
}
</style>